import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, notification, Tree, Typography } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import FormLabel from '../../../components/FormLabel';
import NormalFormLabel from '../../../components/NormalFormLabel';
import CustomSelect from '../../../components/CustomSelect';
import { LIST_STATUS_ROLE } from '../../../constants/appSelect';
import { useMutation } from '@tanstack/react-query';
import { updateRoleRequest } from '../../../services/roleRequest';

const SuaNhomQuyen = ({
  open,
  setOpen,
  dataAllPermissions,
  refetchDataPermissionGroups,
  permissionGroupInfo,
  setPermissionGroupInfo,
}) => {
  const [form] = Form.useForm();
  const [permissions, setPermissions] = useState(null);
  const handleCancel = () => {
    setOpen(false);
    setPermissionGroupInfo(null);
  };

  useEffect(() => {
    if (permissionGroupInfo) {
      form.setFieldsValue(permissionGroupInfo);
      setPermissions(permissionGroupInfo?.permission_ids);
    }
  }, [permissionGroupInfo, form]);

  // handle submit form
  const { mutate: mutateUpdatePermissionGroup, isPending: isLoadingUpdatePermissionGroup } = useMutation({
    mutationFn: updateRoleRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Chỉnh sửa thông tin nhóm quyền thành công!',
        });
        refetchDataPermissionGroups();
        form.resetFields();
        setPermissionGroupInfo(null);
        setOpen(false);
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    mutateUpdatePermissionGroup({ ...data, permissions: permissions, id: permissionGroupInfo.id });
  };

  return (
    <Modal title="Sửa nhóm quyền" open={open} onCancel={handleCancel} footer={null} width={840}>
      <Form layout="vertical" form={form} onFinish={handleSubmitForm} requiredMark={false}>
        <Form.Item
          label={<FormLabel text="Tên nhóm quyền" />}
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên nhóm quyền' }]}
        >
          <Input allowClear placeholder="Nhập tên nhóm quyền" />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Mô tả" />} name="description">
          <Input allowClear placeholder="Nhập mô tả..." />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Trạng thái" />}
          name="status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
        >
          <CustomSelect placeholder="Chọn trạng thái..." options={LIST_STATUS_ROLE} />
        </Form.Item>

        <>
          <Typography.Text className={'mb-4 block text-lg'}>Vui lòng chọn tính năng</Typography.Text>
          <Tree
            checkable
            defaultExpandAll={true}
            checkedKeys={permissions}
            treeData={dataAllPermissions
              ?.filter((item) => item?.status === 1)
              ?.map((itemPermissionGroup) => ({
                title: itemPermissionGroup.name,
                key: `permission_group_${itemPermissionGroup.id}`,
                children: itemPermissionGroup?.permissions
                  ?.filter((item) => item?.status === 1)
                  ?.map((itemPermission) => ({
                    title: itemPermission.name,
                    key: `permission_${itemPermission.id}`,
                    children: itemPermission.actions.map((i) => ({
                      title: i.name,
                      key: i.id,
                    })),
                  })),
              }))}
            onCheck={(checkedKeys, e) => {
              let permissionTemp = permissions;
              if (e.checked === false && e.node.children) {
                const itemKey = e.node.key.replace(/_\d+$/, '');
                if (itemKey === 'permission_group') {
                  const id_children = e.node.children.flatMap((item) => {
                    if (item.children) return item.children.map((i) => i.key);
                    else return item.key;
                  });
                  permissionTemp = permissionTemp.filter((item) => !id_children.includes(item));
                } else if (itemKey === 'permission') {
                  const id_children = e.node.children.map((item) => item.key);
                  permissionTemp = permissionTemp.filter((item) => !id_children.includes(item));
                }
              } else if (e.checked === true && e.node.children) {
                const itemKey = e.node.key.replace(/_\d+$/, '');
                if (itemKey === 'permission_group') {
                  const id_children = e.node.children.flatMap((item) => {
                    if (item.children) return item.children.map((i) => i.key);
                    else return item.key;
                  });
                  permissionTemp = [...permissionTemp, ...id_children];
                } else if (itemKey === 'permission') {
                  const id_children = e.node.children.map((item) => item.key);
                  permissionTemp = [...permissionTemp, ...id_children];
                }
              } else if (e.checked === true && !e.node.children) {
                permissionTemp = [...permissionTemp, e.node.key];
              } else if (e.checked === false && !e.node.children) {
                permissionTemp = permissionTemp.filter((item) => item !== e.node.key);
              }
              setPermissions(permissionTemp);
            }}
          />
        </>

        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>
            <CloseOutlined /> Hủy bỏ
          </Button>
          <Button loading={isLoadingUpdatePermissionGroup} type="primary" htmlType="submit">
            <SaveOutlined /> Lưu lại
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default SuaNhomQuyen;
